<div class="dashboard-wrap">
  <container-dashboard-header
    [userData]="authFacade.userData$ | async"
    [sideNavDrawer]="sideNavDrawer$"
    (logout)="authFacade.logoutWithSkid()"
  >
  </container-dashboard-header>
  <mat-drawer-container class="dashboard-body" [hasBackdrop]="isBackdropAvailable">
    <mat-drawer #drawer [mode]="drawerMode" (closedStart)="updateSideNavDrawer()" class="nav-bar-color">
      <dashboard-nav-bar
        [sideNavDrawer]="drawer"
        [activeMenuItem$]="selectedMenuItem$"
        [menuNavigation$]="menuNavigation$"
      ></dashboard-nav-bar>
    </mat-drawer>
    <mat-drawer-content>
      <dashboard-nav-icons *ngIf="isMenuIconsAvailable" [activeMenuItem$]="selectedMenuItem$"></dashboard-nav-icons>
      <div class="dashboard-content">
        <ng-content></ng-content>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>

  <container-dashboard-footer></container-dashboard-footer>
</div>
